import React, { useState, useEffect } from 'react';
import { Grid, FormControlLabel, Checkbox, FormGroup, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import range from 'lodash/range';
import { getStyles } from './styles';

interface GradeListProps {
  handleChange: ((selectedGrades: string) => void);
  grades?: string;
}

export default function GradeList({ handleChange, grades }: GradeListProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  const [checkedGrades, setCheckedGrades] = useState<boolean[]>([]);

  useEffect(() => {
    const selected = Object.keys(checkedGrades).filter(grade => (
        checkedGrades[parseInt(grade)] === true
    )).join();

    handleChange(selected);
  }, [checkedGrades, handleChange]);

  useEffect(() => {
    if (grades) {
        const gradesArray = grades.split(',');
        let checked: boolean[] = [];
        gradesArray.forEach(grade => {
            checked = ({ ...checked, [parseInt(grade)]: true })
        })
        setCheckedGrades(checked);
    }
  }, [grades])

  const handleGradesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedGrades({ ...checkedGrades, [event.target.value]: event.target.checked });
  };

  return (
    <>
      <Grid>
        <Typography sx={styles.gradeSectionLabel}>Make course set available for the following grade levels</Typography>
      </Grid>
      <Grid sx={styles.gradeGrid}>
        <FormGroup sx={{ flexDirection: 'row' }}>
          {range(1,13).map(grade => (
            <FormControlLabel key={grade}
              sx={styles.gradeCheckboxLabel}
              control={
                <Checkbox
                  checked={!!checkedGrades[grade]}
                  onChange={handleGradesChange}
                  value={grade}
                />
              }
              label={<Typography>{grade}</Typography>}
            />
          ))}
        </FormGroup>
      </Grid>
    </>
  );
}
